import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  computed,
  input,
} from '@angular/core';
import { centerTextPlugin } from '@kinet-open-network/client/shared/util';
import { Plugin } from 'chart.js';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'kon-doughnut-chart',
  standalone: true,
  imports: [CommonModule, ChartModule],
  template: ` <div class="flex justify-center items-center relative">
    <p-chart
      type="doughnut"
      [data]="data"
      [options]="options()"
      [responsive]="true"
      [width]="chartOptions.width"
      [height]="chartOptions.height"
      [plugins]="plugins"
    >
    </p-chart>
  </div>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoughnutChartComponent {
  @Input() data: any;
  @Input() chartOptions: any = {
    height: '100%',
  };
  centerText = input<number | string | null>(0);

  options = computed(() => ({
    ...this.chartOptions,
    plugins: {
      ...this.chartOptions.plugins,
      centerText: this.centerText(),
    },
  }));

  plugins: Plugin<any>[] = [centerTextPlugin];
}
